import React from "react";
import PropTypes from "prop-types";
import getPathogenicityColor from "../../../common/helpers/getPathogenicityColor";
import getPathogenicityName from "../../../common/helpers/getPathogenicityName";

function PathogenicityPill({
  pathogenicity,
  withPlainBackground,
  children,
  color,
}) {
  const backgroundColor = color || getPathogenicityColor(pathogenicity);
  const name = getPathogenicityName(pathogenicity);
  return withPlainBackground ? (
    <div className="tw-flex tw-gap-2 tw-items-center tw-capitalize tw-rounded">
      <div
        className="tw-rounded-full"
        style={{ backgroundColor, width: "0.7em", height: "0.7em" }}
      />
      {children || name}
    </div>
  ) : (
    <span
      className=" tw-px-1 tw-py-1 tw-capitalize tw-rounded tw-inline-block"
      style={{ backgroundColor, color: "white" }}
    >
      {children || name}
    </span>
  );
}

PathogenicityPill.propTypes = {
  color: PropTypes.string,
  pathogenicity: PropTypes.string,
  withPlainBackground: PropTypes.bool,
  children: PropTypes.node,
};

PathogenicityPill.defaultProps = {
  pathogenicity: "",
  color: "",
  withPlainBackground: false,
  children: null,
};

export default React.memo(PathogenicityPill);
